import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { HeatmapsDialogsPagesComponent } from './dialogs/pages/pages.component';
import { HeatmapsDashboardGridComponent } from './pages/dashboard/grid/grid.component';
import { HeatmapsDashboardTableComponent } from './pages/dashboard/table/table.component';
import { HeatmapsDashboardComponent } from './pages/dashboard/dashboard.component';
import { ComponentsModule } from '@client/app/components/components.module';
import { LayoutModule, SwitchButtonModule } from '@monsido/angular-shared-components';
import { CommonModule } from '@angular/common';
import { UpgradePipeModule } from '@client/app/filters/upgrade-pipe.module';

import { PipesModule } from '@monsido/core/pipes/pipes.module';
import { TranslateModule } from '@client/app/modules/translate.module';
import { ExtensionModule } from '@client/app/modules/extension/extension.module';
import { MonActionMenuModule } from '@client/ng2/shared/components/action-menu/action-menu.module';
import { FormsModule } from '@angular/forms';
import { NgbTooltipMfeModule } from '@client/mfe/overlay/ngb-tooltip-mfe.module';

@NgModule({
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [
        CommonModule,
        ComponentsModule,
        SwitchButtonModule,
        UpgradePipeModule,
        NgbTooltipMfeModule,
        PipesModule,
        TranslateModule,
        LayoutModule,
        MonActionMenuModule,
        ExtensionModule,
        FormsModule,
    ],
    declarations: [
        HeatmapsDialogsPagesComponent,
        HeatmapsDashboardGridComponent,
        HeatmapsDashboardTableComponent,
        HeatmapsDashboardComponent,
    ],
    exports: [
        HeatmapsDialogsPagesComponent,
        HeatmapsDashboardGridComponent,
        HeatmapsDashboardTableComponent,
        HeatmapsDashboardComponent,
    ],
})
export class UpgradeHeatmapsModule {}
